import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from './views/Solicitudes.vue';
// import Dashboard from './views/Dashboard.vue';
import {isAuthenticated, isNotAuthenticated} from './vue-apollo';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: isAuthenticated,
    },
    {
      path: '/documentos',
      name: 'Documentos',
      component: () => import('./views/Documentos.vue'),
      beforeEnter: isAuthenticated,
    },
    {
      path: '/requisitos',
      name: 'Requisitos',
      component: () => import('./views/Requisitos.vue'),
      beforeEnter: isAuthenticated,
    },
    {
      path: '/solicitudes',
      name: 'Solicitudes',
      component: () => import('./views/Solicitudes.vue'),
      beforeEnter: isAuthenticated,
    },
    {
      name: 'SolicitudesModulo',
      path: '/solicitudes/:modulo',
      component: () => import('./views/SolicitudesModulo.vue'),
      children: [
        {
          name: 'SolicitudMedico',
          path: 'usuario/:userId',
          component: () => import('./views/SolicitudMedico.vue'),
        },
      ],
      beforeEnter: isAuthenticated,
    },
    {
      path: '/plantillas',
      component: () => import('./views/Plantillas.vue'),
    },
    {
      path: '/invitar',
      component: () => import('./views/Invitar.vue'),
      beforeEnter: isAuthenticated,
    },
    {
      path: '/pagos-por-confirmar',
      component: () => import('./views/PagosPorConfirmar.vue'),
      beforeEnter: isAuthenticated,
    },
    {
      path: '/mi-perfil',
      component: () => import('./views/Perfil.vue'),
      beforeEnter: isAuthenticated,
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('./views/Login.vue'),
      beforeEnter: isNotAuthenticated,
    },
  ],
});
